import { FirebaseService } from './../../services/firebase.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppComponent } from './../../app.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.page.html',
  styleUrls: ['./home.page.scss'],
})
export class HomePage implements OnInit {
  cc: number;
  code: string = '';
  constructor(
    private app: AppComponent,
    private router: Router,
    private route: ActivatedRoute,
    private firebaseService: FirebaseService
  ) {}

  ngOnInit() {

    this.route.queryParams.subscribe((params) => {
      const uid = params['d'] ?? '';
      if (uid) {
        this.firebaseService.getUserByUID(uid).subscribe((usuario) => {
          if (usuario && usuario.Cedula) {
            this.cc = usuario.Cedula
            this.consultarResultados();
          }
        });
      }
    });
  }

  async continuar() {
    this.route.queryParams
      .subscribe(async (params) => {
        const isValidQuery = this.firebaseService.verifyCode(params);
        if (isValidQuery) {
          const isAvailable = await this.firebaseService.checkAvailableTest();
          if (isAvailable) {
            this.router.navigate(['descripcion']);
          } else {
            alert('⚠️ No hay disponibilidad, contacta con el administrador');
          }
        }
      })
      .unsubscribe();
  }
  
  consultarResultados() {
    if (!this.cc || this.cc.toString().trim() === '') {
      alert('⚠️ Ingresa un número de cédula válido');
      return;
    }
    this.app.navegarResultados( this.cc,'/resultados');
  }
}
